import styled, { css } from 'styled-components';


import { DropdownContainer, StyledDropdown } from '../../ui-helpers/Dropdown/Dropdown-styled';
import { Container } from '../../ui-helpers/Slider/styled';
import { SvgIcon } from '../../ui-helpers';

export const StoneGroupWrapper = styled.div`
	display: flex;
	justify-content: space-between;
  align-items: center;
	flex-shrink: 0;

	min-height: 0;
	padding: 20px 0 0 0;
`;

export const StoneGroupTitle = styled.div`
  display: flex;
  align-items: center;

  font-weight: 700;
  font-size: 12px;
  line-height: 15px;

  letter-spacing: 0.03em;

  margin-right: 20px;
`;

export const Image = styled.img`
  width: ${({ width = 25 }) => `${width}px`};
  height: ${({ height = 25 }) => `${height}px`};
  object-fit: cover;
  border-radius: 50%;
  ${({ showBorder, borderWidth }: { showBorder: boolean, borderWidth: number }) => showBorder && css`
    border: ${borderWidth}px solid ${ props => props.theme.colors.fallow };  
  `}
  margin-bottom: 10px;

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    margin-bottom: 4px;
	};
`;

export const MenuSection = styled.div
`
  
`;

export const StyledTabTitle = styled.div`
  display: flex;
  justify-content: space-between;
  
  font-weight: 500;
  font-size: 12px;
  line-height: 13px;
  letter-spacing: 0.03em;
`;

export const DropdownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  
  width: 190px;
`;

export const OptionItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  text-align: center;
  letter-spacing: 0.03em;

  padding: 10px 5px;

  width: 25%;

  cursor: pointer;
  
  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    padding: 0px 5px;
    font-size: 10px;
  }
`;

export const StoneConfigs = styled.div`
  display: inline-grid;
  grid-template-columns: calc(50% - 10px) calc(50% - 10px);
  width: 100%;
  column-gap: 20px; 

  @media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
    
  };
`;

export const StoneItem = styled.div`
  display: inline-grid;
   width: 100%;
  grid-template-columns:100%;
  row-gap:20px;
`;


export const SliderTitle = styled.div`
	font-size: 12px;
	font-weight: 700;
	text-align: center;
  margin-bottom: 25px;
`;

export const SliderContainer = styled.div<{disabled:boolean}>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	
	padding: 20px 0px;
	
	${({disabled, theme}:{disabled?:boolean, theme:any}) => disabled && css`
    color: ${theme.colors.silver};
  `}
`;

export const StyledArrow = styled(SvgIcon)`
  margin-left: 15px;
  width: 5%;
  vertical-align: middle;
  
  transform: rotateZ(90deg);
  
  ${({isActive, theme}:{isActive:boolean, theme:any}) => isActive && css`
    transform: rotateZ(-90deg);
    path {
        fill: ${theme.colors.fallow}
     }
  `}
`;

export const SectionTitle = styled.div
`
  margin-left: 25px;
`

export const OptionsContainer = styled.div
`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`